<template>
  <div class="column is-10">
    Dashboard
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
};
</script>
